import { render, staticRenderFns } from "./TransactionAmount.vue?vue&type=template&id=a5126aea&scoped=true"
import script from "./TransactionAmount.vue?vue&type=script&lang=js"
export * from "./TransactionAmount.vue?vue&type=script&lang=js"
import style0 from "./TransactionAmount.vue?vue&type=style&index=0&id=a5126aea&prod&lang=css"
import style1 from "./TransactionAmount.vue?vue&type=style&index=1&id=a5126aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5126aea",
  null
  
)

export default component.exports